<button
    class="nav-time-line relative !p-[4px]"
    id="notification-popup"
    type="button"
    pnButton
    icon
    [pnOverlay]="notificationRef"
    [overlayType]="_isMobile ? 'sideBarBottom' : 'dropdown'"
    [overlayPosition]="_overlayPosition"
    blockScroll
    (overlayOpenChange)="handleOpenNotification($event)"
>
    <div class="size-[25px] flex-row-center mb:size-7">
        @if (reloadLoading()) {
            <svg-icon
                class="icon:fill-primary-500"
                svgClass="animate-spin size-[25px] mb:size-7"
                src="/assets/icons/loading.svg"
            />
        } @else {
            <svg
                class="mb:size-7"
                width="25"
                height="25"
                viewBox="0 0 25 25"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
                <path
                    opacity="0.4"
                    d="M12.9321 6.94L12.9356 10.27"
                    stroke="#06AAF1"
                    stroke-width="1.5"
                    stroke-miterlimit="10"
                    stroke-linecap="round"
                />
                <path
                    d="M12.9476 2.5C9.26763 2.50382 6.29072 5.4869 6.29454 9.1669L6.29671 11.2669C6.29742 11.9469 6.01847 12.9672 5.66908 13.5476L4.40127 15.6689C3.62263 16.9797 4.16415 18.4391 5.60464 18.9176C10.3863 20.5027 15.5563 20.4973 20.3346 18.9024C21.6842 18.451 22.2625 16.8704 21.5313 15.6511L20.2591 13.5324C19.9085 12.9528 19.6274 11.9231 19.6267 11.2531L19.6245 9.15308C19.6107 5.4931 16.6076 2.49621 12.9476 2.5Z"
                    stroke="#06AAF1"
                    stroke-width="1.5"
                    stroke-miterlimit="10"
                    stroke-linecap="round"
                />
                <path
                    opacity="0.4"
                    d="M16.275 19.3166C16.2769 21.1466 14.7784 22.6481 12.9484 22.65C12.0384 22.6509 11.198 22.2718 10.5974 21.6724C9.9968 21.0731 9.61593 20.2335 9.61499 19.3235"
                    stroke="#06AAF1"
                    stroke-width="1.5"
                    stroke-miterlimit="10"
                />
            </svg>
        }
    </div>

    <span
        *ngIf="hasUnreadNotification()"
        class="absolute right-1 top-1.5 size-2 rounded-full bg-secondary-500"
    ></span>
</button>

<ng-template #notificationRef>
    <div class="notification-ref">
        <div
            class="flex flex-row items-center justify-between border-b border-neutral-03 px-3 py-[10px]"
        >
            <h4
                class="font-lato-bold text-xl font-bold text-neutral-08"
                i18n="@@notification.labels.notification"
            >
                Thông báo
            </h4>
            <button
                [pnOverlay]="menuItems"
                [overlayPosition]="_menuPosition"
                *ngIf="hasUnreadNotification()"
            >
                <svg-icon src="/assets/icons/more-circle.svg" svgClass="size-6" />
            </button>

            <ng-template #menuItems let-overlay="overlay">
                <ul class="overflow-hidden rounded bg-neutral-01 shadow-dropdown">
                    <li
                        class="menu-item cursor-pointer border-b border-divider"
                        i18n="@@notification.buttons.markAllAsRead"
                        (click)="markAllAsRead()"
                    >
                        Đánh dấu tất cả đã đọc
                    </li>
                </ul>
            </ng-template>
        </div>
        <div class="h-[calc(100%_-_45px)] mb:h-[calc(100svh_-_119px)]">
            <pn-notification-list
                *ngIf="notifications.length || loading(); else noData"
                [loading]="loading()"
                [notifications]="notifications"
                [allNotificationsLoaded]="allNotificationsLoaded"
                (scrollToBottom)="listenerScrollToBottom($event)"
                (itemChange)="reloadNotifications()"
            ></pn-notification-list>
        </div>

        <div class="hidden border-t border-neutral-03 p-4 mb:flex">
            <button
                type="button"
                (click)="closeDialog()"
                class="w-full !text-base font-bold"
                pnButton
                rounded="lg"
                i18n="@@common.buttons.close"
            >
                Đóng
            </button>
        </div>
    </div>
</ng-template>

<ng-template #noData>
    <div class="no-data py-6 mb:h-full mb:justify-center">
        <svg-icon
            [svgStyle]="{ 'height.px': 65, 'width.px': 150 }"
            src="/assets/icons/empty-box.svg"
        ></svg-icon>
        <p i18n="@@notification.labels.not-found">Không tìm thấy thông báo nào!</p>
    </div>
</ng-template>
